import Vue from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/icons/components'
import dayjs from 'dayjs'
import * as filters from '@/filters'
import i18n from '@/lang'

// import '@/permission'

import lang from 'element-ui/lib/locale/lang/id'
import locale from 'element-ui/lib/locale'

Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string]: Function })[key])
})

Vue.use(ElementUI, {
    size: 'medium',
    i18n: (key: any, value: any) => i18n.t(key, value)
});

Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})

// setup language
locale.use(lang)

Vue.config.productionTip = false

Vue.prototype.$dayjs = dayjs

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
